import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { IPopupModel, LinkListGroupItem } from '@mwe/models';
import {
  ButtonLinkComponent,
  HeadlineComponent,
  HeadlineService,
  LinkListGroupComponent,
  OrderProductsPopupComponent,
  TransparentCardComponent,
} from '@mwe/ui/components';
import { NavigationStateService, PopupService } from '@mwe/services';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-product-add-footer',
  templateUrl: './product-add-footer.component.html',
  providers: [HeadlineService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TransparentCardComponent, TranslateDirective, ButtonLinkComponent, HeadlineComponent, LinkListGroupComponent],
})
export class ProductAddFooterComponent {
  items = signal<LinkListGroupItem[]>([
    {
      label: 'products-add.product-search.faq.customerNumberWithoutBill',
      href: 'https://www.wienenergie.at/faqs/kundenummer-ohne-rechnung/',
    },
    {
      label: 'products-add.product-search.faq.multipleContractsAccessAccount',
      href: 'https://www.wienenergie.at/faqs/mehrere-vertraege/',
    },
  ]);

  private popupService = inject(PopupService);
  private navigationStateService = inject(NavigationStateService);

  openOrderProductsPopup(): void {
    const model: IPopupModel = {
      id: 'products-footer-order-products',
      component: OrderProductsPopupComponent,
      componentData: this.navigationStateService.navbarConfig.hasAllProcesses,
      dismissable: true,
      titleKey: 'newClient.title',
      modalSize: 'xl',
    };
    this.popupService.openV2(model);
  }
}
